/**
 * Org-mode / Logseq planning-date helpers. Logseq writes `DEADLINE: <2026-10-05 Mon>` and
 * `SCHEDULED: <2026-09-28 Mon>`; we store the bare ISO date (`2026-10-05`) on a block's `due`/
 * `scheduled` attr. These convert between the two. Pure and DOM-free (unit-testable in core).
 */
const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const ISO_RE = /(\d{4})-(\d{2})-(\d{2})/;

/** True for a well-formed `YYYY-MM-DD` (also rejects impossible calendar dates like 2026-13-40). */
export function isIsoDate(s: string | null | undefined): s is string {
  if (!s) return false;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (!m) return false;
  const d = new Date(`${s}T00:00:00Z`);
  return !Number.isNaN(d.getTime()) && d.getUTCMonth() + 1 === Number(m[2]) && d.getUTCDate() === Number(m[3]);
}

/**
 * Parse a Logseq planning value into an ISO date. Accepts the org timestamp `<YYYY-MM-DD Day>`
 * (repeaters/times after the date are ignored) or a bare `YYYY-MM-DD`. Returns null when there's no
 * valid date.
 */
export function parseOrgDate(value: string): string | null {
  const m = ISO_RE.exec(value);
  if (!m) return null;
  const iso = `${m[1]}-${m[2]}-${m[3]}`;
  return isIsoDate(iso) ? iso : null;
}

/** Format an ISO date back to the org timestamp `<YYYY-MM-DD Day>` (UTC weekday). */
export function formatOrgDate(iso: string): string {
  const d = new Date(`${iso}T00:00:00Z`);
  return `<${iso} ${DOW[d.getUTCDay()]}>`;
}
